import { useNowFlowNode } from "@/hooks/services/useFlow";
import {
  confirmContractNodeCodes,
  pendingSupplierUploadNodeCodes,
  supplierContractUploadShouldApplyNodeCodes,
} from "../constant";
import { isMatch } from "@/utils/flow.helper";

/**
 * 自定义 Hook，用于匹配合同流程节点
 * @returns 包含节点匹配结果的对象
 */
export function useContractFlowNodeMatcher(insId?: number) {
  const currentNodeCode = useNowFlowNode(insId);

  const isMatchPendingSupplierUploadNode = isMatch(
    pendingSupplierUploadNodeCodes,
    currentNodeCode,
  );

  const isMatchConfirmContractNode = isMatch(
    confirmContractNodeCodes,
    currentNodeCode,
  );

  const isMatchSupplierContractUploadShouldApplyNode = isMatch(
    supplierContractUploadShouldApplyNodeCodes,
    currentNodeCode,
  );

  return {
    /** 是否匹配 "待供应商上传" 节点 */
    isMatchPendingSupplierUploadNode,
    /** 是否匹配 "确认合同" 节点 */
    isMatchConfirmContractNode,
    /** 是否匹配 "供应商发起申请第一次审批（采购经理）" 节点 */
    isMatchSupplierContractUploadShouldApplyNode,
  };
}
